"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = exports.HelpText = exports.PTextLight = exports.Label = exports.PText = exports.Heading5 = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = exports.Wrapper = void 0;
const native_1 = __importStar(require("styled-components/native"));
exports.Wrapper = native_1.default.View `
  margin: 20px;
`;
exports.Heading1 = native_1.default.Text `
  font-family: ${({ theme }) => theme.bpCore.typography.heading1.fontFamily};
  font-size: ${({ theme }) => theme.bpCore.typography.heading1.fontSize};
  line-height: ${({ theme }) => theme.bpCore.typography.heading1.lineHeight};
  letter-spacing: ${({ theme }) => theme.bpCore.typography.heading1.letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.Heading2 = native_1.default.Text `
  font-family: ${({ theme }) => theme.bpCore.typography.heading2.fontFamily};
  font-size: ${({ theme }) => theme.bpCore.typography.heading2.fontSize};
  line-height: ${({ theme }) => theme.bpCore.typography.heading3.lineHeight};
  letter-spacing: ${({ theme }) => theme.bpCore.typography.heading2.letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.Heading3 = native_1.default.Text `
  font-family: ${({ theme }) => theme.bpCore.typography.heading3.fontFamily};
  font-size: ${({ theme }) => theme.bpCore.typography.heading3.fontSize};
  line-height: ${({ theme }) => theme.bpCore.typography.heading3.lineHeight};
  letter-spacing: ${({ theme }) => theme.bpCore.typography.heading3.letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.Heading4 = native_1.default.Text `
  font-family: ${({ fontFamily, theme }) => fontFamily || theme.bpCore.typography.heading4.fontFamily};
  font-size: ${({ fontSize, theme }) => fontSize || theme.bpCore.typography.heading4.fontSize};
  line-height: ${({ lineHeight, theme }) => lineHeight || theme.bpCore.typography.heading4.lineHeight};
  letter-spacing: ${({ letterSpacing, theme }) => letterSpacing || theme.bpCore.typography.heading4.letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.Heading5 = native_1.default.Text `
  font-family: ${({ theme }) => theme.bpCore.typography.heading5.fontFamily};
  font-size: ${({ theme }) => theme.bpCore.typography.heading5.fontSize};
  line-height: ${({ theme }) => theme.bpCore.typography.heading5.lineHeight};
  letter-spacing: ${({ theme }) => theme.bpCore.typography.heading5.letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.PText = native_1.default.Text `
  font-family: ${({ type, theme }) => theme.bpCore.typography.pText[type].fontFamily};
  font-size: ${({ type, theme }) => theme.bpCore.typography.pText[type].fontSize};
  line-height: ${({ type, theme }) => theme.bpCore.typography.pText[type].lineHeight};
  letter-spacing: ${({ type, theme }) => theme.bpCore.typography.pText[type].letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.Label = native_1.default.Text `
  font-family: ${({ theme }) => theme.bpCore.typography.label.fontFamily};
  font-size: ${({ theme }) => theme.bpCore.typography.label.fontSize};
  line-height: ${({ theme }) => theme.bpCore.typography.label.lineHeight};
  letter-spacing: ${({ theme }) => theme.bpCore.typography.label.letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.PTextLight = native_1.default.Text `
  font-family: ${({ type, theme }) => theme.bpCore.typography.pTextLight[type].fontFamily};
  font-size: ${({ type, theme }) => theme.bpCore.typography.pTextLight[type].fontSize};
  line-height: ${({ type, theme }) => theme.bpCore.typography.pTextLight[type].lineHeight};
  letter-spacing: ${({ type, theme }) => theme.bpCore.typography.pTextLight[type].letterSpacing};
  color: ${({ color, theme }) => color || theme.bpCore.colors.text};
`;
exports.HelpText = native_1.default.Text `
  font-family: ${({ theme }) => theme.bpCore.typography.helpText.fontFamily};
  font-size: ${({ theme }) => theme.bpCore.typography.helpText.fontSize};
  line-height: ${({ theme }) => theme.bpCore.typography.helpText.lineHeight};
  letter-spacing: ${({ theme }) => theme.bpCore.typography.helpText.letterSpacing};
  color: ${({ color }) => color};
`;
exports.Anchor = native_1.default(exports.PText) `
  color: ${({ theme, color }) => color || theme.bpCore.colors.anchor};
  ${({ underline, theme, color }) => underline &&
    native_1.css `
      text-decoration: underline;
      text-decoration-color: ${color || theme.bpCore.colors.anchor};
    `}
`;
